var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dialogModel',{attrs:{"title":_vm.dialogTitle,"visible":_vm.dialogVisible,"footer":false},on:{"handleClose":_vm.handleClose}},[_c('div',{staticClass:"main-body"},[_c('div',{staticClass:"msg-content"},[_vm._v(_vm._s(_vm.dataObj.content || "--"))]),_c('div',{staticClass:"main-time"},[_vm._v(_vm._s(_vm.$tool.turnTime(_vm.dataObj.sendTime)))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }